/**
 * Tiny pub/sub store. No framework, just an event emitter.
 * Components call `store.get()` and `store.subscribe()`.
 */
export class Store<T> {
  private value: T;
  private listeners = new Set<(v: T) => void>();

  constructor(initial: T) {
    this.value = initial;
  }

  get(): T { return this.value; }

  set(next: T | ((prev: T) => T)) {
    this.value = typeof next === 'function' ? (next as (p: T) => T)(this.value) : next;
    for (const fn of this.listeners) fn(this.value);
  }

  subscribe(fn: (v: T) => void): () => void {
    this.listeners.add(fn);
    fn(this.value);
    return () => this.listeners.delete(fn);
  }
}

export interface AppState {
  booted: boolean;
  onboardingDone: boolean;
  currentMonth: string;
  income: number;
  filter: 'all' | 'paid' | 'unpaid';
  theme: 'light' | 'dark';
  amountsHidden: boolean;
}

export const appState = new Store<AppState>({
  booted: false,
  onboardingDone: false,
  currentMonth: '2026-03',
  income: 20000,
  filter: 'all',
  theme: 'light',
  amountsHidden: false,
});
